<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add to Group'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/person-circle-outline.svg'"
              [label]="'User'"
              [items]="userItems"
              [form]="form.controls.user"
              formControlName="user"
              [submitted]="submitted"
              [errorMessage]="'Please select a user'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/people-circle-outline.svg'"
              [label]="'Add to Group'"
              [items]="teamItems"
              [form]="form.controls.team"
              formControlName="team"
              [submitted]="submitted"
              [errorMessage]="'Please select a group'" />
          </tidy-row>
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Add to Group'"
          [action]="boundAddUserToTeam"
          class="primary" />
        @if (isConvertingAdminToMember()) {
          <tidy-alert>
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Adding an admin to a group will change their user type to group member. This means they will only be able to see users and properties in their group.'" />
            </tidy-row>
          </tidy-alert>
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
